module.exports = __webpack_public_path__ + "assets/img/df0eaa87e647760491a2c9915ef7d35d.png";